export default __webpack_public_path__ + "static/media/Tutorial-Step-2.3.4989b8cd.jpg";